import React, {useCallback, useEffect, useState} from "react";
import {connect, useDispatch} from "react-redux";
import store, {AppState} from "../../../store/store";
import {actions, Control, Form} from "react-redux-form";
import {Button} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import _ from 'lodash';
import CustomInput from "../../../components/custom-input/custom-input";
import {
    createListOfRelaysNames,
    createManualRelaysListFromShadow,
    createManualRelaysListToSave, createOneManualOptionToSave, createVoltageOneManualOptionToSave
} from "../../../services/relays.service";
import {getManualSettings, updateManulSettings} from "../../../services/state";
import Loader from "react-loader-spinner";
import {updateOutputActiveStatus} from "../../../services/rotation.service";

interface IManualSettings {
    deviceNames: object;
}

interface IManualSettingsRow {
    name: string;
    on: () => void;
    off: () => void;
}
const ManualSettingsRow: React.FC<IManualSettingsRow> = (props) => {
    const {t} = useTranslation();
    const [variant, setVariant] = useState<string | null>(null)

    useEffect(() => {
        if (variant === 'on' || variant === 'off') {
            setTimeout(() => setVariant(null), 3000)
        }
    }, [variant])

    const onClickOn = () => {
        setVariant('on')
        props.on()
    }

    const onClickOff = () => {
        setVariant('off')
        props.off()
    }
    return (
        <div className='row manual-settings-row'>
            <span className='col'>{props.name}</span>
            <Button variant={variant === 'on' ? 'contained' : 'outlined'} type='button' onClick={onClickOn} color="primary" className='modal-default-button mr-3'>
                {t('on')}
            </Button>
            <Button variant={variant === 'off' ? 'contained' : 'outlined'} type='button' onClick={onClickOff} color="primary" className='modal-default-button'>
                {t('off')}
            </Button>
            
        </div>
    )
}
const PureManualSettings: React.FC<IManualSettings> = (props) => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [variant, setVariant] = useState<string | null>(null)
    useEffect(() => {
        if (variant === 'on' || variant === 'off') {
            setTimeout(() => setVariant(null), 3000)
        }
    }, [variant])

    const onClickOn = () => {
        setVariant('on')
        handleVoltageChangeStatus(true)
    }

    const onClickOff = () => {
        setVariant('off')
        handleVoltageChangeStatus(false)
    }
    useEffect(() => {
        setLoading(true);
        getManualSettings().then(
            (res) => {
                const d = JSON.parse(res.data.payload);
                const tmp = createManualRelaysListFromShadow(d)
            
                setData(tmp);
                dispatch(actions.change('manual-settings.analog1Value', _.get(tmp, 'analog1Value', 0)));
            }
        ).finally(() => setLoading(false))
    }, []);
    useEffect(() => console.log("NAMES: ", props.deviceNames), [props.deviceNames])
    const handleChangeStatus = (name: string, index: number, status: boolean) => {
        const objectToSend = createOneManualOptionToSave(name, index, status);
        return Promise.all([updateManulSettings(objectToSend)])
    }
    const handleVoltageChangeStatus = (status: boolean) => {
        const state = store.getState();
        const objectToSend = createVoltageOneManualOptionToSave(status, _.get(state, 'manual-settings.analog1Value'));
        return Promise.all([updateManulSettings(objectToSend)])
    }
    if (!loading && data !== {}) {
        return (
            <div className='d-flex justify-content-center w-100 align-items-start router-container'>
                <Form
                    model='manual-settings'>
                    <div className='card default-card'>
                        <div className="card-body">
                            {
                                [1, 2, 3, 4, 5].map((num) => <ManualSettingsRow name={_.get(props.deviceNames, 'relays.relay' + num, 'r' + num)} on={() => handleChangeStatus('relay' + num, num, true)} off={() => handleChangeStatus('relay' + num, num, false)}/>)
                            }
                            {
                                [1, 2, 3, 4].map((num) => <ManualSettingsRow name={_.get(props.deviceNames, 'irda.irda' + num, 'irda' + num)} on={() => handleChangeStatus('irda' + num, num, true)} off={() => handleChangeStatus('irda' + num, num, false)}/>)
                            }
                            <div className='row manual-settings-row'>
                                <span className='col pt-3'>{_.get(props.deviceNames, 'analogs.analog1', 'analog1')}</span>
                                <div className='default-field mr-3'>
                                    <Control
                                        model={".analog1Value"}
                                        component={CustomInput}
                                        label={t('value')}
                                        id={'analog1Value'} />
                                </div>
                                <Button variant={variant === 'on' ? 'contained' : 'outlined'} type='button' onClick={() => onClickOn()} color="primary" className='modal-default-button default-button-height mr-3 mt-1'>
                                    {t('on')}
                                </Button>
                                <Button variant={variant === 'off' ? 'contained' : 'outlined'} type='button' onClick={() => onClickOff()} color="primary" className='modal-default-button default-button-height mt-1'>
                                    {t('off')}
                                </Button>
                            
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        )
    }
    return <div className='w-100 d-flex justify-content-center pt-5'>
        <Loader
            type="Puff"
            color="#555374"
            height={100}
            width={100}
            timeout={3000} //3 secs

        />
    </div>;
    // if (data !== {} && !loading) {
    //     return (
    //         <div className='d-flex justify-content-center w-100 align-items-start router-container'>
    //             HELLO
    //         </div>
    //     )
    // }
}
const mapStateToPropsDevice = (state: AppState) => ({
    state: state
});
export const ManualSettings = connect(mapStateToPropsDevice)(PureManualSettings);